/// <amd-module name="Wit/WorkItemForm/History/index" />
export * from "./HistoryTab";
